import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import DashboardService from 'services/DashboardService'
// import axios from 'axios'

export const initialState = {
    analyticsData: {
        data: [],
        isLoading: false,
        error: false,
    },

    analyticsGraph: {
        data: [],
        isLoading: false,
        error: false,
    },

    ftmData: {
        data: [],
        isLoading: false,
        error: false,
    },

    ftmDataWithChargePoints: {
        data: [],
        isLoading: false,
        error: false,
    },
    
    ftmDataWithChargePointsByVendorErrorCode: {
        data: [],
        isLoading: false,
        error: false,
    },

    ftmTableData: {
        data: [],
        isLoading: false,
        error: false,
    },

    modelBreakdownData: {
        data: [],
        isLoading: false,
        error: false,
    },

    chargePointsDeployedData: {
        data: [],
        isLoading: false,
        error: false,
    },

    connectorStatusData: {
        data: [],
        isLoading: false,
        error: false,
    },

    initialPowerData: {
        data: [],
        isLoading: false,
        error: false,
    },

    totalTransactionDurationData: {
        data: [],
        isLoading: false,
        error: false,
    },

    utilizationRatiosData: {
        data: [],
        isLoading: false,
        error: false,
    },

    operatorsChargePointsBreakdownData: {
        data: [],
        isLoading: false,
        error: false,
    },

    totalTransactionAnalyticsData: {
        data: [],
        isLoading: false,
        error: false,
    },

    transactionForDashboardData: {
        data: [],
        isLoading: false,
        error: false,
    },
    totalInstalledPowerData: {
        data: [],
        isLoading: false,
        error: false,
    },

    uptimeRatiosData: {
        data: [],
        isLoading: false,
        error: false,
    },

    executiveDashboardData: {
        data: [],
        isLoading: false,
        error: false,
    },

    executiveDashboardLiveData: {
        data: [],
        isLoading: false,
        error: false,
    },

    executiveDashboardSummaryData: {
        data: [],
        isLoading: false,
        error: false,
    },

    executiveChargePointDashboardLiveData: {
        data: [],
        isLoading: false,
        error: false,
    },

    executiveChargePointDashboardSummaryData: {
        data: [],
        isLoading: false,
        error: false,
    },
    
    averageUptimesData: {
        data: [],
        isLoading: false,
        error: false,
    },
}

export const fetchAnalyticsData = createAsyncThunk('analytics/getAnalyticsData', async (data, { rejectWithValue }) => {
    try {
        const response = await DashboardService.getAnalyticsData(data)
        return response.data
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})

export const fetchAnalyticsGraph = createAsyncThunk('analytics/getAnalyticsGraph', async (data, { rejectWithValue }) => {
    try {
        const response = await DashboardService.getAnalyticsGraph(data)
        return response.data
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})

export const fetchFtmData = createAsyncThunk('analytics/getFtmData', async (params, { rejectWithValue }) => {
    try {
        const response = await DashboardService.getFtmData(params)
        return response.data
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})

export const fetchFtmDataWithChargePoints = createAsyncThunk('analytics/getFtmDataWithChargePoints', async (params, { rejectWithValue }) => {
    try {
        const response = await DashboardService.getFtmDataWithChargePoints(params)
        return response.data
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})

export const fetchFtmDataWithChargePointsByVendorErrorCode = createAsyncThunk('analytics/getFtmDataWithChargePointsByVendorErrorCode', async (params, { rejectWithValue }) => {
    try {
        const response = await DashboardService.getFtmDataWithChargePointsByVendorErrorCode(params)
        return response.data
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})

export const fetchFtmDataToExcel = createAsyncThunk(
    'analytics/getFtmDataToExcel',
    async (data, { rejectWithValue }) => {
        try {
            const response = await DashboardService.getFtmDataToExcel(data)
            return response
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error')
        }
    }
)

export const fetchFtmTableData = createAsyncThunk(
    'analytics/getFtmTableData',
    async (params, { rejectWithValue }) => {
        try {
            const response = await DashboardService.getFtmTableData(params)
            return response.data
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error')
        }
    }
)

export const fetchModelBreakdown = createAsyncThunk(
    'analytics/getModelBreakdown',
    async (data, { rejectWithValue }) => {
        try {
            const response = await DashboardService.getModelBreakdown()
            return response.data
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error')
        }
    }
)

export const fetchChargePointsDeployed = createAsyncThunk(
    'analytics/getChargePointsDeployed',
    async (data, { rejectWithValue }) => {
        try {
            const response = await DashboardService.getChargePointsDeployed()
            return response.data
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error')
        }
    }
)

export const fetchConnectorStatus = createAsyncThunk(
    'analytics/getConnectorStatus',
    async (data, { rejectWithValue }) => {
        try {
            const response = await DashboardService.getConnectorStatus()
            return response.data
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error')
        }
    }
)

export const fetchInitialPower = createAsyncThunk('analytics/getInitialPower', async (data, { rejectWithValue }) => {
    try {
        const response = await DashboardService.getInitialPower()
        return response.data
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})

export const fetchTotalTransactionDuration = createAsyncThunk(
    'analytics/getTotalTransactionDuration',
    async (data, { rejectWithValue }) => {
        try {
            const response = await DashboardService.getTotalTransactionDuration()
            return response.data
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error')
        }
    }
)

export const fetchUtilizationRatios = createAsyncThunk(
    'analytics/getUtilizationRatios',
    async (data, { rejectWithValue }) => {
        try {
            const response = await DashboardService.getUtilizationRatios()
            return response.data
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error')
        }
    }
)

export const fetchOperatorsChargePointsBreakdown = createAsyncThunk(
    'analytics/getOperatorsChargePointsBreakdown',
    async (data, { rejectWithValue }) => {
        try {
            const response = await DashboardService.getOperatorsChargePointsBreakdown()
            return response.data
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error')
        }
    }
)

export const fetchTotalTransactionAnalytics = createAsyncThunk(
    'analytics/getTotalTransactionAnalytics',
    async (data, { rejectWithValue }) => {
        try {
            const response = await DashboardService.getTotalTransactionAnalytics()
            return response.data
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error')
        }
    }
)

export const fetchTransactionForDashboard = createAsyncThunk(
    'analytics/getTransactionForDashboard',
    async (data, { rejectWithValue }) => {
        try {
            const response = await DashboardService.getTransactionForDashboard()
            return response.data
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error')
        }
    }
)

export const fetchTotalInstalledPower = createAsyncThunk(
    'analytics/getTotalInstalledPower',
    async (data, { rejectWithValue }) => {
        try {
            const response = await DashboardService.getTotalInstalledPower()
            return response.data
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error')
        }
    }
)

export const fetchUptimeRatios = createAsyncThunk('analytics/getUptimeRatios', async (data, { rejectWithValue }) => {
    try {
        const response = await DashboardService.getUptimeRatios()
        return response.data
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})

export const fetchExecutiveDashboard = createAsyncThunk(
    'analytics/getExecutiveDashboard',
    async (params, { rejectWithValue }) => {
        try {
            const response = await DashboardService.getExecutiveDashboard(params)
            return response.data
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error')
        }
    }
)

export const fetchExecutiveDashboardLive = createAsyncThunk(
    'analytics/getExecutiveDashboardLive',
    async (params, { rejectWithValue }) => {
        try {
            const response = await DashboardService.getExecutiveDashboardLive(params)
            return response.data
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error')
        }
    }
)

export const fetchExecutiveDashboardSummary = createAsyncThunk(
    'analytics/getExecutiveDashboardSummary',
    async (params, { rejectWithValue }) => {
        try {
            const response = await DashboardService.getExecutiveDashboardSummary(params)
            return response.data
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error')
        }
    }
)

export const fetchExecutiveChargePointDashboardLive = createAsyncThunk(
    'analytics/getExecutiveChargePointDashboardLive',
    async (params, { rejectWithValue }) => {
        try {
            const response = await DashboardService.getExecutiveChargePointDashboardLive(params)
            return response.data
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error')
        }
    }
)

export const fetchExecutiveChargePointDashboardSummary = createAsyncThunk(
    'analytics/getExecutiveChargePointDashboardSummary',
    async (params, { rejectWithValue }) => {
        try {
            const response = await DashboardService.getExecutiveChargePointDashboardSummary(params)
            return response.data
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error')
        }
    }
)

export const fetchAverageUptime = createAsyncThunk(
    'analytics/fetchAverageUptime',
    async (data, { rejectWithValue }) => {
        try {
            const response = await DashboardService.getAverageUptimes()
            return response.data
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error')
        }
    }
)

export const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(fetchAnalyticsData.pending, (state, action) => {
                state.analyticsData.isLoading = true
            })
            .addCase(fetchAnalyticsData.rejected, (state, action) => {
                state.analyticsData.isLoading = false
                state.analyticsData.error = action.error.message
            })
            .addCase(fetchAnalyticsData.fulfilled, (state, action) => {
                state.analyticsData.isLoading = false
                state.analyticsData.error = false
                state.analyticsData.data = action.payload
            })

            .addCase(fetchAnalyticsGraph.pending, (state, action) => {
                state.analyticsGraph.isLoading = true
            })
            .addCase(fetchAnalyticsGraph.rejected, (state, action) => {
                state.analyticsGraph.isLoading = false
                state.analyticsGraph.error = action.error.message
            })
            .addCase(fetchAnalyticsGraph.fulfilled, (state, action) => {
                state.analyticsGraph.isLoading = false
                state.analyticsGraph.error = false
                state.analyticsGraph.data = action.payload
            })

            .addCase(fetchFtmData.pending, (state, action) => {
                state.ftmData.isLoading = true
            })
            .addCase(fetchFtmData.rejected, (state, action) => {
                state.ftmData.isLoading = false
                state.ftmData.error = action.error.message
            })
            .addCase(fetchFtmData.fulfilled, (state, action) => {
                state.ftmData.isLoading = false
                state.ftmData.error = false
                state.ftmData.data = action.payload
            })

            .addCase(fetchFtmDataWithChargePoints.pending, (state, action) => {
                state.ftmDataWithChargePoints.isLoading = true
            })
            .addCase(fetchFtmDataWithChargePoints.rejected, (state, action) => {
                state.ftmDataWithChargePoints.isLoading = false
                state.ftmDataWithChargePoints.error = action.error.message
            })
            .addCase(fetchFtmDataWithChargePoints.fulfilled, (state, action) => {
                state.ftmDataWithChargePoints.isLoading = false
                state.ftmDataWithChargePoints.error = false
                state.ftmDataWithChargePoints.data = action.payload
            })

            .addCase(fetchFtmDataWithChargePointsByVendorErrorCode.pending, (state, action) => {
                state.ftmDataWithChargePointsByVendorErrorCode.isLoading = true
            })
            .addCase(fetchFtmDataWithChargePointsByVendorErrorCode.rejected, (state, action) => {
                state.ftmDataWithChargePointsByVendorErrorCode.isLoading = false
                state.ftmDataWithChargePointsByVendorErrorCode.error = action.error.message
            })
            .addCase(fetchFtmDataWithChargePointsByVendorErrorCode.fulfilled, (state, action) => {
                state.ftmDataWithChargePointsByVendorErrorCode.isLoading = false
                state.ftmDataWithChargePointsByVendorErrorCode.error = false
                state.ftmDataWithChargePointsByVendorErrorCode.data = action.payload
            })

            .addCase(fetchFtmTableData.pending, (state, action) => {
                state.ftmTableData.isLoading = true
            })
            .addCase(fetchFtmTableData.rejected, (state, action) => {
                state.ftmTableData.isLoading = false
                state.ftmTableData.error = action.error.message
            })
            .addCase(fetchFtmTableData.fulfilled, (state, action) => {
                state.ftmTableData.isLoading = false
                state.ftmTableData.error = false
                state.ftmTableData.data = action.payload
            })

            .addCase(fetchModelBreakdown.pending, (state, action) => {
                state.modelBreakdownData.isLoading = true
            })
            .addCase(fetchModelBreakdown.rejected, (state, action) => {
                state.modelBreakdownData.isLoading = false
                state.modelBreakdownData.error = action.error.message
            })
            .addCase(fetchModelBreakdown.fulfilled, (state, action) => {
                state.modelBreakdownData.isLoading = false
                state.modelBreakdownData.error = false
                state.modelBreakdownData.data = action.payload
            })

            .addCase(fetchChargePointsDeployed.pending, (state, action) => {
                state.chargePointsDeployedData.isLoading = true
            })
            .addCase(fetchChargePointsDeployed.rejected, (state, action) => {
                state.chargePointsDeployedData.isLoading = false
                state.chargePointsDeployedData.error = action.error.message
            })
            .addCase(fetchChargePointsDeployed.fulfilled, (state, action) => {
                state.chargePointsDeployedData.isLoading = false
                state.chargePointsDeployedData.error = false
                state.chargePointsDeployedData.data = action.payload
            })

            .addCase(fetchConnectorStatus.pending, (state, action) => {
                state.connectorStatusData.isLoading = true
            })
            .addCase(fetchConnectorStatus.rejected, (state, action) => {
                state.connectorStatusData.isLoading = false
                state.connectorStatusData.error = action.error.message
            })
            .addCase(fetchConnectorStatus.fulfilled, (state, action) => {
                state.connectorStatusData.isLoading = false
                state.connectorStatusData.error = false
                state.connectorStatusData.data = action.payload
            })

            .addCase(fetchInitialPower.pending, (state, action) => {
                state.initialPowerData.isLoading = true
            })
            .addCase(fetchInitialPower.rejected, (state, action) => {
                state.initialPowerData.isLoading = false
                state.initialPowerData.error = action.error.message
            })
            .addCase(fetchInitialPower.fulfilled, (state, action) => {
                state.initialPowerData.isLoading = false
                state.initialPowerData.error = false
                state.initialPowerData.data = action.payload
            })

            .addCase(fetchTotalTransactionDuration.pending, (state, action) => {
                state.totalTransactionDurationData.isLoading = true
            })
            .addCase(fetchTotalTransactionDuration.rejected, (state, action) => {
                state.totalTransactionDurationData.isLoading = false
                state.totalTransactionDurationData.error = action.error.message
            })
            .addCase(fetchTotalTransactionDuration.fulfilled, (state, action) => {
                state.totalTransactionDurationData.isLoading = false
                state.totalTransactionDurationData.error = false
                state.totalTransactionDurationData.data = action.payload
            })

            .addCase(fetchUtilizationRatios.pending, (state, action) => {
                state.utilizationRatiosData.isLoading = true
            })
            .addCase(fetchUtilizationRatios.rejected, (state, action) => {
                state.utilizationRatiosData.isLoading = false
                state.utilizationRatiosData.error = action.error.message
            })
            .addCase(fetchUtilizationRatios.fulfilled, (state, action) => {
                state.utilizationRatiosData.isLoading = false
                state.utilizationRatiosData.error = false
                state.utilizationRatiosData.data = action.payload
            })

            .addCase(fetchOperatorsChargePointsBreakdown.pending, (state, action) => {
                state.operatorsChargePointsBreakdownData.isLoading = true
            })
            .addCase(fetchOperatorsChargePointsBreakdown.rejected, (state, action) => {
                state.operatorsChargePointsBreakdownData.isLoading = false
                state.operatorsChargePointsBreakdownData.error = action.error.message
            })
            .addCase(fetchOperatorsChargePointsBreakdown.fulfilled, (state, action) => {
                state.operatorsChargePointsBreakdownData.isLoading = false
                state.operatorsChargePointsBreakdownData.error = false
                state.operatorsChargePointsBreakdownData.data = action.payload
            })

            .addCase(fetchTotalTransactionAnalytics.pending, (state, action) => {
                state.totalTransactionAnalyticsData.isLoading = true
            })
            .addCase(fetchTotalTransactionAnalytics.rejected, (state, action) => {
                state.totalTransactionAnalyticsData.isLoading = false
                state.totalTransactionAnalyticsData.error = action.error.message
            })
            .addCase(fetchTotalTransactionAnalytics.fulfilled, (state, action) => {
                state.totalTransactionAnalyticsData.isLoading = false
                state.totalTransactionAnalyticsData.error = false
                state.totalTransactionAnalyticsData.data = action.payload
            })

            .addCase(fetchTransactionForDashboard.pending, (state, action) => {
                state.transactionForDashboardData.isLoading = true
            })
            .addCase(fetchTransactionForDashboard.rejected, (state, action) => {
                state.transactionForDashboardData.isLoading = false
                state.transactionForDashboardData.error = action.error.message
            })
            .addCase(fetchTransactionForDashboard.fulfilled, (state, action) => {
                state.transactionForDashboardData.isLoading = false
                state.transactionForDashboardData.error = false
                state.transactionForDashboardData.data = action.payload
            })

            .addCase(fetchTotalInstalledPower.pending, (state, action) => {
                state.totalInstalledPowerData.isLoading = true
            })
            .addCase(fetchTotalInstalledPower.rejected, (state, action) => {
                state.totalInstalledPowerData.isLoading = false
                state.totalInstalledPowerData.error = action.error.message
            })
            .addCase(fetchTotalInstalledPower.fulfilled, (state, action) => {
                state.totalInstalledPowerData.isLoading = false
                state.totalInstalledPowerData.error = false
                state.totalInstalledPowerData.data = action.payload
            })

            .addCase(fetchUptimeRatios.pending, (state, action) => {
                state.uptimeRatiosData.isLoading = true
            })
            .addCase(fetchUptimeRatios.rejected, (state, action) => {
                state.uptimeRatiosData.isLoading = false
                state.uptimeRatiosData.error = action.error.message
            })
            .addCase(fetchUptimeRatios.fulfilled, (state, action) => {
                state.uptimeRatiosData.isLoading = false
                state.uptimeRatiosData.error = false
                state.uptimeRatiosData.data = action.payload
            })

            .addCase(fetchAverageUptime.pending, (state, action) => {
                state.averageUptimesData.isLoading = true
            })
            .addCase(fetchAverageUptime.rejected, (state, action) => {
                state.averageUptimesData.isLoading = false
                state.averageUptimesData.error = action.error.message
            })
            .addCase(fetchAverageUptime.fulfilled, (state, action) => {
                state.averageUptimesData.isLoading = false
                state.averageUptimesData.error = false
                state.averageUptimesData.data = action.payload
            })

            .addCase(fetchExecutiveDashboard.pending, (state, action) => {
                state.executiveDashboardData.isLoading = true
            })
            .addCase(fetchExecutiveDashboard.rejected, (state, action) => {
                state.executiveDashboardData.isLoading = false
                state.executiveDashboardData.error = action.error.message
            })
            .addCase(fetchExecutiveDashboard.fulfilled, (state, action) => {
                state.executiveDashboardData.isLoading = false
                state.executiveDashboardData.error = false
                state.executiveDashboardData.data = action.payload
            })

            .addCase(fetchExecutiveDashboardLive.pending, (state, action) => {
                state.executiveDashboardLiveData.isLoading = true
            })
            .addCase(fetchExecutiveDashboardLive.rejected, (state, action) => {
                state.executiveDashboardLiveData.isLoading = false
                state.executiveDashboardLiveData.error = action.error.message
            })
            .addCase(fetchExecutiveDashboardLive.fulfilled, (state, action) => {
                state.executiveDashboardLiveData.isLoading = false
                state.executiveDashboardLiveData.error = false
                state.executiveDashboardLiveData.data = action.payload
            })

            .addCase(fetchExecutiveDashboardSummary.pending, (state, action) => {
                state.executiveDashboardSummaryData.isLoading = true
            })
            .addCase(fetchExecutiveDashboardSummary.rejected, (state, action) => {
                state.executiveDashboardSummaryData.isLoading = false
                state.executiveDashboardSummaryData.error = action.error.message
            })
            .addCase(fetchExecutiveDashboardSummary.fulfilled, (state, action) => {
                state.executiveDashboardSummaryData.isLoading = false
                state.executiveDashboardSummaryData.error = false
                state.executiveDashboardSummaryData.data = action.payload
            })

            .addCase(fetchExecutiveChargePointDashboardLive.pending, (state, action) => {
                state.executiveChargePointDashboardLiveData.isLoading = true
            })
            .addCase(fetchExecutiveChargePointDashboardLive.rejected, (state, action) => {
                state.executiveChargePointDashboardLiveData.isLoading = false
                state.executiveChargePointDashboardLiveData.error = action.error.message
            })
            .addCase(fetchExecutiveChargePointDashboardLive.fulfilled, (state, action) => {
                state.executiveChargePointDashboardLiveData.isLoading = false
                state.executiveChargePointDashboardLiveData.error = false
                state.executiveChargePointDashboardLiveData.data = action.payload
            })

            .addCase(fetchExecutiveChargePointDashboardSummary.pending, (state, action) => {
                state.executiveChargePointDashboardSummaryData.isLoading = true
            })
            .addCase(fetchExecutiveChargePointDashboardSummary.rejected, (state, action) => {
                state.executiveChargePointDashboardSummaryData.isLoading = false
                state.executiveChargePointDashboardSummaryData.error = action.error.message
            })
            .addCase(fetchExecutiveChargePointDashboardSummary.fulfilled, (state, action) => {
                state.executiveChargePointDashboardSummaryData.isLoading = false
                state.executiveChargePointDashboardSummaryData.error = false
                state.executiveChargePointDashboardSummaryData.data = action.payload
            })
    },
})

export default dashboardSlice.reducer
